<template>
  <v-form ref="p1form" v-model="p1form" lazy-validation>
    <v-card color="grey lighten-4" max-width="700px">
      <v-toolbar :color="eventFromParent.color" dark>
        <v-toolbar-title>
          <span v-if="!formFlg" v-html="eventFromParent.name"></span>
          <ryou-input
            v-if="formFlg"
            v-model="model.title"
            :value="model.title"
            :label="'タイトル'"
            :maxlength="10"
          ></ryou-input>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="changeFormFlg" v-if="updFlg">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>予定</v-card-title>
      <v-card-text>
        <span v-if="!formFlg" v-html="'物件グループとか'"></span>
        <span v-if="formFlg">
          <v-row>
            <v-col cols="4" class="noBotPadding">
              <RyouSelect
                :label="'物件グループ選択'"
                :items="buildGroupItems"
                :itemText="'build_group_name'"
                :itemValue="'build_group_id'"
                v-model="selectedBuildGroup"
                :value="selectedBuildGroup"
              >
              </RyouSelect>
            </v-col>
            <v-col cols="4" class="noBotPadding">
              <RyouSelect
                :label="'物件選択'"
                :items="buildingItems"
                :itemText="'building_name'"
                :itemValue="'building_id'"
                v-model="selectedBuilding"
                :value="selectedBuilding"
              >
              </RyouSelect>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4" class="noBotPadding">
              <RyouSelect
                :label="'作業区分選択'"
                :items="workClassItems"
                :itemText="'code_text'"
                :itemValue="'code_value'"
                v-model="selectedWorkClass"
                :value="selectedWorkClass"
              >
              </RyouSelect>
            </v-col>
          </v-row>
        </span>

        <span v-if="!formFlg">
          <v-row>
            <v-col cols="2" v-html="'作業日'"></v-col>
            <v-col
              cols="2"
              v-html="dateFormat(eventFromParent.model.work_date)"
            ></v-col>
          </v-row>
        </span>
        <span v-if="formFlg">
          <v-row>
            <v-col cols="4">
              <ryou-date-format
                v-if="formFlg"
                v-model="model.work_date"
                :value="model.work_date"
                :type="'date'"
                :format="'$1/$2/$3'"
                :label="' 作業日'"
              >
              </ryou-date-format>
            </v-col>
          </v-row>
        </span>

        <span v-if="!formFlg">
          <v-row>
            <v-col cols="2">
              <span v-html="'予定'"></span>
            </v-col>
            <v-col
              cols="2"
              v-html="eventFromParent.model.work_start_time"
            ></v-col>
            <v-col cols="1">
              <h2>{{ this.wavyLineMark }}</h2>
            </v-col>
            <v-col
              cols="2"
              v-html="eventFromParent.model.work_end_time"
            ></v-col>
          </v-row>
        </span>
        <span v-if="formFlg">
          <v-row>
            <v-col cols="1">
              <span v-html="'予定'"></span>
            </v-col>
            <v-col cols="2">
              <ryou-select
                :label="'時'"
                :items="hourLabels"
                :itemText="'text'"
                :itemValue="'text'"
                v-model="selectedStartHour"
                :value="selectedStartHour"
              >
              </ryou-select>
            </v-col>
            <v-col cols="2">
              <ryou-select
                :label="'分'"
                :items="minutesLabels"
                :itemText="'text'"
                :itemValue="'text'"
                v-model="selectedStartMinutes"
                :value="selectedStartMinutes"
              >
              </ryou-select>
            </v-col>
            <v-col cols="1">
              <h2>{{ this.wavyLineMark }}</h2>
            </v-col>
            <v-col cols="2">
              <ryou-select
                :label="'時'"
                :items="hourLabels"
                :itemText="'text'"
                :itemValue="'text'"
                v-model="selectedEndHour"
                :value="selectedEndHour"
              >
              </ryou-select>
            </v-col>
            <v-col cols="2">
              <ryou-select
                :label="'分'"
                :items="minutesLabels"
                :itemText="'text'"
                :itemValue="'text'"
                v-model="selectedEndMinutes"
                :value="selectedEndMinutes"
              >
              </ryou-select>
            </v-col>
          </v-row>
        </span>

        <span v-if="!formFlg">
          <v-row>
            <v-col v-html="eventFromParent.model.message"></v-col>
          </v-row>
        </span>
        <ryou-textarea
          v-if="formFlg"
          v-model="model.message"
          :value="model.message"
          :label="'注意事項'"
          :outlined="true"
          :maxlength="512"
        ></ryou-textarea>
      </v-card-text>

      <v-divider class="mx-4"></v-divider>

      <v-card-title>実績</v-card-title>
      <v-card-text>
        <span v-if="!achieveFlg" v-html="'未登録'"></span>
        <span v-if="!formFlg && achieveFlg">
          <v-row>
            <v-col cols="2">
              <span v-html="'実績'"></span>
            </v-col>
            <v-col
              cols="2"
              v-html="eventFromParent.model.work_start_time"
            ></v-col>
            <v-col cols="1">
              <h2>{{ this.wavyLineMark }}</h2>
            </v-col>
            <v-col
              cols="2"
              v-html="eventFromParent.model.work_end_time"
            ></v-col>
          </v-row>
        </span>
        <span v-if="formFlg && achieveFlg">
          <v-row>
            <v-col cols="1">
              <span v-html="'実績'"></span>
            </v-col>
            <v-col cols="2">
              <ryou-select
                :label="'時'"
                :items="hourLabels"
                :itemText="'text'"
                :itemValue="'text'"
                v-model="selectedStartHour"
                :value="selectedStartHour"
              >
              </ryou-select>
            </v-col>
            <v-col cols="2">
              <ryou-select
                :label="'分'"
                :items="minutesLabels"
                :itemText="'text'"
                :itemValue="'text'"
                v-model="selectedStartMinutes"
                :value="selectedStartMinutes"
              >
              </ryou-select>
            </v-col>
            <v-col cols="1">
              <h2>{{ this.wavyLineMark }}</h2>
            </v-col>
            <v-col cols="2">
              <ryou-select
                :label="'時'"
                :items="hourLabels"
                :itemText="'text'"
                :itemValue="'text'"
                v-model="selectedEndHour"
                :value="selectedEndHour"
              >
              </ryou-select>
            </v-col>
            <v-col cols="2">
              <ryou-select
                :label="'分'"
                :items="minutesLabels"
                :itemText="'text'"
                :itemValue="'text'"
                v-model="selectedEndMinutes"
                :value="selectedEndMinutes"
              >
              </ryou-select>
            </v-col>
          </v-row>
        </span>
      </v-card-text>

      <v-divider class="mx-4"></v-divider>

      <v-card-title>通知先設定</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="8">
            <ryou-select
              :items="userClassItems"
              :label="'通知先'"
              :itemText="'code_text'"
              :itemValue="'code_value'"
              v-model="selectedUserClass"
              :value="selectedUserClass"
            >
            </ryou-select>
          </v-col>
        </v-row>
        <v-row v-show="false">
          <UserSelectDialog
            ref="modalForm"
            :url="url"
            @setDataByChild="setDataByChild"
          >
          </UserSelectDialog>
        </v-row>

        <v-row class="noBotPadding">
          <v-col cols="4" v-if="$useMailDelivery">
            <ryou-checkbox
              v-model="mailDelivaryFlg"
              :value="mailDelivaryFlg"
              :label="'メール送信有無'"
            >
            </ryou-checkbox>
          </v-col>

          <v-col cols="4" v-if="$useBulletinBoard">
            <ryou-checkbox
              v-model="vulletinBoradFlg"
              :value="vulletinBoradFlg"
              :label="'掲示板掲載チェック'"
            ></ryou-checkbox>
          </v-col>

          <v-col cols="4" class="txtInput" v-if="$useBulletinBoard">
            <ryou-input
              v-model="noticeInfo.board_publish_time"
              :value="noticeInfo.board_publish_time"
              :label="'掲示板掲載時間'"
              :maxlength="3"
            ></ryou-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-menu up open-on-hover transition="slide-y-transition" right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  <span>宛先ユーザを見る</span>
                </v-btn>
              </template>
              <ryou-textarea
                v-model="selectedUsers"
                :value="selectedUsers"
                :label="'ユーザ選択'"
                :outlined="true"
                :rows="8"
                :clearable="true"
                :autGrow="true"
                :readolny="true"
                :backgroundColor="'grey lighten-2'"
              ></ryou-textarea>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <ryou-black-btn
          :label="'閉じる'"
          :handlerClick="close"
          :iconCls="'mdi-close'"
        ></ryou-black-btn>
        <v-spacer></v-spacer>
        <ryou-black-btn
          :label="'登録'"
          :handlerClick="handleOk"
        ></ryou-black-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouSelect from "@/components/formInput/RyouSelect";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
import RyouTextarea from "@/components/formInput/RyouTextarea.vue";
import RyouCheckbox from "@/components/formInput/RyouCheckbox.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";

import UserSelectDialog from "./UserSelectDialog.vue";

export default {
  components: {
    RyouInput,
    RyouSelect,
    RyouDateFormat,
    RyouTextarea,
    RyouCheckbox,
    RyouBlackBtn,

    UserSelectDialog,
  },
  props: {
    getGeneralFunc: {
      type: Function,
      required: false,
      defaulg: () => {},
    },
    eventFromParent: {
      type: Object,
      required: true,
      default: () => {},
    },
    closeFromParent: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data: () => ({
    hourLabels: [
      { text: "0" },
      { text: "1" },
      { text: "2" },
      { text: "3" },
      { text: "4" },
      { text: "5" },
      { text: "6" },
      { text: "7" },
      { text: "8" },
      { text: "9" },
      { text: "10" },
      { text: "11" },
      { text: "12" },
      { text: "13" },
      { text: "14" },
      { text: "15" },
      { text: "16" },
      { text: "17" },
      { text: "18" },
      { text: "19" },
      { text: "20" },
      { text: "21" },
      { text: "22" },
      { text: "23" },
    ],
    minutesLabels: [
      { text: "00" },
      { text: "01" },
      { text: "02" },
      { text: "03" },
      { text: "04" },
      { text: "05" },
      { text: "06" },
      { text: "07" },
      { text: "08" },
      { text: "09" },
      { text: "10" },
      { text: "11" },
      { text: "12" },
      { text: "13" },
      { text: "14" },
      { text: "15" },
      { text: "16" },
      { text: "17" },
      { text: "18" },
      { text: "19" },
      { text: "20" },
      { text: "21" },
      { text: "22" },
      { text: "23" },
      { text: "24" },
      { text: "25" },
      { text: "26" },
      { text: "27" },
      { text: "28" },
      { text: "29" },
      { text: "30" },
      { text: "31" },
      { text: "32" },
      { text: "33" },
      { text: "34" },
      { text: "35" },
      { text: "36" },
      { text: "37" },
      { text: "38" },
      { text: "39" },
      { text: "40" },
      { text: "41" },
      { text: "42" },
      { text: "43" },
      { text: "44" },
      { text: "45" },
      { text: "46" },
      { text: "47" },
      { text: "48" },
      { text: "49" },
      { text: "50" },
      { text: "51" },
      { text: "52" },
      { text: "53" },
      { text: "54" },
      { text: "55" },
      { text: "56" },
      { text: "57" },
      { text: "58" },
      { text: "59" },
    ],
    day: ["日", "月", "火", "水", "木", "金", "土"],
    wavyLineMark: "～",
    colonMark: "：",
    achieveFlg: false,
    selectedStartHour: "",
    selectedStartMinutes: "",
    selectedEndHour: "",
    selectedEndMinutes: "",
    selectedBuildGroup: "",
    selectedBuilding: "",
    selectedWorkClass: "",
    selectedUserClass: "",
    selectedUsers: "",
    p1form: true,
    formFlg: false,
    updFlg: true,
    mailDelivaryFlg: false,
    vulletinBoradFlg: false,
    color: "",
    model: {
      work_date: "",
      title: "",
      details: "",
      work_class: "",
      work_start_time: "",
      work_end_time: "",
      remark: "",
    },
    noticeInfo: {
      bard_publish_time: "",
      publish_start_date: "",
      publish_end_date: "",
    },
    buildGroupItems: [],
    workClassItems: [],
    buildingItems: [],
    userClassItems: [],
    url: {},
  }),
  mounted() {
    //console.log(this.minWidth)
    this.setItemLists();
  },
  watch: {
    selectedBuildGroup(value) {
      //物件一覧を取得
      let params = {
        build_group_id: value,
      };
      this.getRequest(
        "/noticeWorkScheduleConfirmation/buildingGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success && data.status == "200") {
          var mapDatas = data.result.map((item) => {
            item.building_id = String(item.building_id);
            return item;
          });
          this.buildingItems = mapDatas;
          this.buildingItems.push(this.selectedBuilding);
        }
      });
    },
    workSelectValue(value) {
      // console.log(value)
    },
    selectedUserClass(value) {
      // console.log("selectUserClassのウォッチャ")
      // console.log(value)
      if (value == "99") {
        this.$refs.modalForm.selectUsers();
      } else if (value != "99") {
        this.textarea1 = "";
      }
      // 通知先寮生以外はクリアする
      //if (value != "3") {
      //  this.buildOptionItems = [];
      //  this.buildSelectValue = "";
      //  this.getBuildIdList();
      //} else if (value == "3" && this.buildSelectValue == 0) {
      //  this.buildSelectValue = "";
      //  this.getBuildIdList();
      //}
    },
  },
  methods: {
    changeFormFlg() {
      // console.log("選択イベント")
      // console.log(this.eventFromParent)
      this.formFlg = !this.formFlg;
      if (this.formFlg) {
        this.edit();
      }
    },
    add() {
      this.updFlg = false;
      this.formFlg = true;
    },
    handleOk() {},
    edit() {
      // console.log("編集")
      this.model.title = this.eventFromParent.name;
      this.model.message = this.eventFromParent.details;
      this.model.work_start_time = this.eventFromParent.start;
      this.model.work_end_time = this.eventFromParent.end;
    },
    close() {
      this.$refs.p1form.resetValidation();
      this.closeFromParent();
    },
    //リストを親クラスから受け取りセット
    setItemLists() {
      this.buildGroupItems = this.getGeneralFunc(1);
      this.workClassItems = this.getGeneralFunc(2);
      this.userClassItems = this.getGeneralFunc(3);
    },
    dateFormat(pDate) {
      var date = new Date(pDate);
      var day = date.getDate();
      var dayOfWeek = date.getDay();
      var str = day + "(" + this.day[dayOfWeek] + ")";
      return str;
    },
    // 個別選択一覧
    setDataByChild(arr) {
      this.notice_user_id = arr[0];
      this.selectedUsers = arr[1];
      // console.log("notice_user_id")
      // console.log(arr[0])
      // console.log("selectedUsers")
      // console.log(arr[1])
    },
  },
};
</script>

<style>
.nopadding {
  padding: 0px;
}

.noBotPadding {
  padding-bottom: 0px;
}

.noRigPadding {
  padding-right: 0px;
}
</style>
